// CRA uses REACT_APP_ prefix — NOT import.meta.env (that's Vite only)
export const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

export const apiFetch = async (path, opts = {}, token, retries = 2) => {
  const method = (opts.method || "GET").toUpperCase();
  const trackBusy = typeof window !== "undefined" && method !== "GET" && !opts.silent;
  const headers = {
    "Content-Type": "application/json",
    ...(token ? { Authorization: token } : {}),
    ...(opts.headers || {}),
  };
  if (trackBusy) window.dispatchEvent(new CustomEvent("zpliq:api-busy", { detail: 1 }));
  try {
    for (let i = 0; i <= retries; i++) {
      try {
        const res  = await fetch(`${API}${path}`, { ...opts, headers });
        const data = await res.json();
        if (res.status === 401 && data.error?.toLowerCase().includes("expired")) {
          localStorage.removeItem("token");
          window.location.reload();
        }
        return data;
      } catch (err) {
        if (i === retries) throw err;
        await new Promise(r => setTimeout(r, 1000 * (i + 1)));
      }
    }
  } finally {
    if (trackBusy) window.dispatchEvent(new CustomEvent("zpliq:api-busy", { detail: -1 }));
  }
};
